/**
 * HTTP action configuration type and validation
 */

export type HttpActionConfigType = {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers?: Record<string, string>;
  body?: string;
  bodyType?: 'json' | 'form' | 'text';
  timeout?: number;
  retryCount?: number;
  continueOnFail?: boolean;
};

export const defaultHttpConfig: HttpActionConfigType = {
  url: '',
  method: 'POST',
  headers: {},
  body: '',
  bodyType: 'json',
  timeout: 30000,
  retryCount: 3,
  continueOnFail: false,
};

export const validateHttpConfig = (
  config: HttpActionConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!config.url || config.url.trim() === '') {
    errors.url = 'URL is required';
  } else {
    // Basic URL validation (allow expressions)
    const urlWithoutExpressions = config.url.replace(
      /\{\{[^}]+\}\}/g,
      'placeholder',
    );
    try {
      new URL(urlWithoutExpressions);
    } catch {
      errors.url = 'Invalid URL format';
    }
  }

  if (!config.method) {
    errors.method = 'Method is required';
  }

  return errors;
};

/**
 * Get preview text for the node display
 */
export const getHttpPreviewText = (config: HttpActionConfigType): string => {
  if (config.url) {
    try {
      const url = new URL(config.url.replace(/\{\{[^}]+\}\}/g, 'placeholder'));
      return `${config.method || 'POST'} ${url.hostname}${url.pathname}`;
    } catch {
      return `${config.method || 'POST'} ${config.url.substring(0, 30)}...`;
    }
  }
  return 'Configure request';
};
